import { faCheck, faClose, faEdit, faEye, faUsers } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { showPopup } from "../../store/thunks/popups";
import { approveOrRejectRegisteredUser, fetchRegisteredUsers } from "../../store/thunks/registrations";
import { showToast } from "../../store/thunks/toasts";
import { POPUPS, USER_STATUS } from "../../utils/constants";
import InplaceProgress from "../DesignSystem/InplaceProgress/InplaceProgress";
import NoData from "../DesignSystem/NoData/NoData";
import Table from "../DesignSystem/Table/Table";
import TableItem from "../DesignSystem/Table/TableItem";
import { getKnowledgeStatusByNumber } from "./RegistrationUtils";

export default connect(
	(state) => ({
		...state.registrations,
	}),
	{ fetchRegisteredUsers, approveOrRejectRegisteredUser, showToast }
)(
	({
		usersList,
		onClickViewUserDetails,
		onClickEditUser,
		fetchingRegisteredUsers,
		fetchingRegisteredUsersComplete,
		onClickApproveUser,
		handleMultiSelectRows,
	}) => {
		const dispatch = useDispatch();
		const { formatMessage } = useIntl();

		const [tableButtons, setTableButtons] = useState([]);
		const [tableHeaders, setTableHeaders] = useState([
			"registration.table.header.photo",
			"registration.table.header.name",
			"registration.table.header.phoneNumber",
			"registration.table.header.age",
			"registration.table.header.region",
			"registration.table.header.city",
			"registration.table.header.medicalConditions",
			"registration.table.header.knowledgeStatus",
			"registration.table.status",
			"registration.table.header.actions",
		]);
		const colWidth = 100 / tableHeaders.length;

		const onClickRejectUser = async (user) => {
			await dispatch(showPopup(POPUPS.REJECT_REQUEST_POPUP, { ...user }));
		};

		const getColorBasedOnStatus = (status) => {
			let colorCode = null;

			if (status === USER_STATUS.APPROVED) {
				colorCode = "text-success";
			} else if (status === USER_STATUS.REJECTED) {
				colorCode = "text-danger";
			} else {
				colorCode = "text-primary";
			}

			return colorCode;
		};

		const getApprovalStatus = (status) => {
			let approvalStatus = null;

			if (status === USER_STATUS.APPROVED) {
				approvalStatus = "registration.status.approved";
			} else if (status === USER_STATUS.REJECTED) {
				approvalStatus = "registration.status.rejected";
			} else {
				approvalStatus = "registration.status.pending";
			}

			return formatMessage({ id: approvalStatus });
		};

		const getTableButtons = (data) => {
			let buttons = [
				{
					label: "view",
					icon: faEye,
					onClick: () => {
						onClickViewUserDetails(data);
					},
				},
				{
					label: "edit",
					icon: faEdit,
					onClick: () => {
						onClickEditUser(data);
					},
				},
			];

			if (data.approvalStatus === USER_STATUS.PENDING) {
				buttons.push(
					{
						label: "approve",
						icon: faCheck,
						buttonClass: "button-success",
						onClick: () => {
							onClickApproveUser(data);
						},
					},
					{
						label: "reject",
						icon: faClose,
						buttonClass: "button-danger",
						onClick: () => {
							onClickRejectUser(data);
						},
					}
				);
			}

			return buttons;
		};

		return (
			<>
				{!fetchingRegisteredUsers && fetchingRegisteredUsersComplete ? (
					<>
						<div className="dashboard-content-body">
							{usersList.length ? (
								<>
									<Table headers={tableHeaders} />
									<div>
										{usersList.map((data) => {
											return (
												<div className="table-items flex direction-row align-items-center justify-content-between">
													<TableItem
														showCheckBox={
															data.approvalStatus !== USER_STATUS.APPROVED ? true : false
														}
														checkBoxId={data.id}
														img={data.photo}
														data={``}
														onClickCheckBox={(e) => {
															handleMultiSelectRows(e);
														}}
														styles={{ width: `${colWidth}%` }}
													/>
													<TableItem
														data={`${data.firstName} ${data.lastName}`}
														styles={{ width: `${colWidth}%` }}
													/>
													<TableItem
														data={data.mobileNumber}
														styles={{ width: `${colWidth}%` }}
													/>
													<TableItem data={data.age} styles={{ width: `${colWidth}%` }} />
													<TableItem data={data.region} styles={{ width: `${colWidth}%` }} />
													<TableItem data={data.city} styles={{ width: `${colWidth}%` }} />
													<TableItem
														data={data.medicalConditions}
														styles={{ width: `${colWidth}%` }}
													/>
													<TableItem
														data={getKnowledgeStatusByNumber(
															data.knowledgeStatus,
															formatMessage
														)}
														styles={{ width: `${colWidth}%` }}
													/>
													<TableItem
														className={getColorBasedOnStatus(data.approvalStatus)}
														data={getApprovalStatus(data.approvalStatus)}
														styles={{ width: `${colWidth}%` }}
													/>
													{tableButtons && (
														<TableItem
															data={""}
															isButtons={true}
															buttons={getTableButtons(data)}
															styles={{ width: `${colWidth}%` }}
														/>
													)}
												</div>
											);
										})}
									</div>
								</>
							) : (
								<NoData
									icon={faUsers}
									description={formatMessage({ id: "registration.nodata.message" })}
								/>
							)}
						</div>
					</>
				) : (
					<InplaceProgress />
				)}
			</>
		);
	}
);
